<template>
  <div class="search-rlsj">
    <div class="u-p5-x-3">
      <template>
        <h4 style="color: aliceblue;margin-top: -30px">
          人脸数据检索
        </h4>
      </template>
      <car-form
        @submit="submit"
        :showformitem="formItemshow"
        :default-form-value="defaultFormValue"
      ></car-form>
    </div>
    <car-img-list
      v-if="imageList.length > 0"
      @carshow="carimgShow"
      :key="refreshKey"
      :image-list="imageList"
      :showlistitem="['cartime', 'name']"
    ></car-img-list>
    <div style="text-align: center; color: #b3b3b3; padding: 0.5rem 0" v-show="loading">
      <i style="font-size: 0.38rem;color#FFF" class="el-icon el-icon-loading"></i>
    </div>
    <div
      v-show="imageList.length == 0 && !loading"
      style="text-align: center; color: #b3b3b3; padding: 0.5rem 0"
    >
      查询结果为空
    </div>
  </div>
</template>

<script>
import CarForm from "@/components/form/carForm.vue";
import CarImgList from "@/components/carImgList.vue";
export default {
  components: {
    CarForm,
    CarImgList,
  },
  data() {
    const typeTime = {
      beginTime: this.$myPlug.timeFormat(
        //new Date().getTime() - 60000 * 60 * 24 * 14,
        new Date().getTime(),
        "yyyy-mm-dd 00:00:00"
      ),
      endTime: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd hh:MM:ss"),
    };
    return {
      setTimer: null,
      isEnd: false,
      loading: false,
      defaultFormValue: {
        passingTime: Object.values(typeTime),
      },
      form: { ...typeTime },
      pageRow: 12,
      pageIndex: 1,
      refreshKey: "t1",
      formItemshow: [
        "personName",
        "personIdcard",
        //"tollgateID",
        "persontollgate",
        "deviceID",
        "passType",
        "passingTime",
      ],
      imageList: [],
    };
  },
  methods: {
    submit(form) {
      this.isEnd=false
      this.form = form;
      this.form.name = form.personName;
      this.form.idcard = form.personIdcard;
      this.form.personType = form.personType || form.passType;
      this.form.beginTime = form.beginTime || form.passingTime[0];
      this.form.endTime = form.endTime || form.passingTime[1];
      this.pageIndex = 1;
      this.getList();
    },
    carimgShow(data) {
      this.$store.commit("boxDetail", {
        oneCardInfo: data,
        title: "详情",
      });
    },
    getList(from) {
      if (from !== "add") this.imageList = [];
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      this.$http
        .POST_facePage(this.form)
        .then((response) => {
          this.loading = false;
          if(response.data&&response.data.length){
          response.data.forEach((item, index) => {
            this.imageList.push(
              Object.assign({}, item, {
                img: item.storageUrl1 || "../../static/img/img_error2.png",
                name: item.name,
                cartime: item.passingTimeFormat,
                tollgate: item.tollgateName,
              })
            );
          });
          console.log(this.imageList);
          this.refreshKey = new Date().getTime();
        }else{
            this.$message("数据已请求完")
            this.isEnd=true
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    scroll(e) {
      // console.log(e.target.scrollTop);
      const bottomHeight =
        e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;
      if (bottomHeight < 300&&!this.isEnd) {
        this.loading = true;
        if (this.setTimer) clearTimeout(this.setTimer);
        this.setTimer = setTimeout(() => {
          this.pageIndex += 1;
          this.getList("add");
        }, 500);
      }
    },
  },
  mounted() {
    document.querySelector(".index-main").addEventListener("scroll", this.scroll);
  },
  created() {
    this.getList();
  },
  destroyed() {
    document.querySelector(".index-main").removeEventListener("scroll", this.scroll);
  },
};
</script>

<style lang="scss">
/*

.tollStationTable {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid rgb(66, 66, 66);
    padding: 4px 6px;
    line-height: 24px;
  }
}
.w-flex-div {
  display: flex;
  > div {
    flex: 1;
    text-align: center;
  }
}
//   组件重建样式

.h-dialog {
  //.el-tabs--border-card>.el-tabs__content{padding: 0;}
  .el-dialog__header {
    background: #20222a;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__title {
    color: #fff;
  }
}

.font-bold {
  font-weight: bold;
  padding: 6px 0;
  font-size: 16px;
  color: #403f3f;
}
.rfid-invalid {
  background: #fff;
  margin: 20px;
  padding: 20px;
  height: 99%;
  overflow: hidden;
  .container-box {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    .small-container {
      border-radius: 4px;
      min-width: 280px;
      padding: 20px;
    }
  }
}
*/
</style>


// WEBPACK FOOTER //
// src/views/search/rlsj.vue